import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { contactInfo } from '../data/mock';

const ContactSection = () => {

  return (
    <section id="contact" className="py-24 bg-page">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-4">Schedule Your Appointment</h2>
          <p className="body-large text-secondary max-w-2xl mx-auto">
            Ready to start your journey to healthier skin? Contact us today 
            to schedule your consultation.
          </p>
        </div>

        <div className="ai-grid">
          {/* Contact Information */}
          <div className="space-y-6">
            {/* Office Hours */}
            <div className="voice-card accent-blue">
              <div className="flex items-center gap-3 mb-4">
                <Clock size={24} className="text-accent-blue-400" />
                <h3 className="voice-card-title">Horarios de Atención</h3>
              </div>
              <div className="space-y-2">
                {Object.entries(contactInfo.hours).map(([day, hours]) => (
                  <div key={day} className="flex justify-between items-center">
                    <span className="capitalize body-small font-medium">{day}:</span>
                    <span className="body-small text-secondary">{hours}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Contact Details */}
            <div className="voice-card accent-orange">
              <h3 className="voice-card-title mb-4">Información de Contacto</h3>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <Phone size={20} className="text-accent-orange-400" />
                  <div>
                    <div className="body-small font-medium">Teléfono</div>
                    <div className="body-small text-secondary">{contactInfo.phone}</div>
                  </div>
                </div>
                
                <div className="flex items-center gap-3">
                  <Mail size={20} className="text-accent-orange-400" />
                  <div>
                    <div className="body-small font-medium">Email</div>
                    <div className="body-small text-secondary">{contactInfo.email}</div>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <MapPin size={20} className="text-accent-orange-400 mt-1" />
                  <div>
                    <div className="body-small font-medium">Dirección</div>
                    <div className="body-small text-secondary">
                      {contactInfo.address.street}<br />
                      {contactInfo.address.reference}<br />
                      {contactInfo.address.neighborhood}<br />
                      {contactInfo.address.city}, {contactInfo.address.state} {contactInfo.address.zip}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Google Maps */}
            <div className="voice-card accent-blue">
              <h3 className="voice-card-title mb-4">Ubicación</h3>
              <div className="w-full h-64 rounded-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3596.6094447147567!2d-100.36923962544273!3d25.659189677358844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8662bf1b8b5a1d3d%3A0x5e9c9c9c9c9c9c9c!2sCalzada%20del%20Valle%20400%2C%20Del%20Valle%2C%2066220%20San%20Pedro%20Garza%20Garc%C3%ADa%2C%20N.L.%2C%20Mexico!5e0!3m2!1sen!2smx!4v1630000000000!5m2!1sen!2smx"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Ubicación Dr. Adrián Cuéllar Barboza"
                ></iframe>
              </div>
              <div className="mt-3 text-center">
                <a 
                  href={contactInfo.googleMapsUrl}
                  className="btn-tag"
                >
                  Ver en Google Maps
                </a>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <div className="voice-card accent-green text-center">
              <h3 className="voice-card-title mb-3">¿Listo para agendar tu cita?</h3>
              <p className="body-small text-secondary mb-4">
                Contáctanos por WhatsApp para agendar tu consulta de manera rápida y fácil.
              </p>
              <a 
                href={`https://wa.me/${contactInfo.whatsapp.replace(/\D/g, '')}?text=${encodeURIComponent(contactInfo.whatsappMessage)}`}
                className="btn-primary inline-block"
              >
                Agendar por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;